import ViewsIcon from "assets/images/analytics/viewIcon.svg";
import FavoritesIcon from "assets/images/analytics/favoriteOutlined.svg";
import ClonesIcon from "assets/images/analytics/cloneIcon.svg";
import UnlocksIcon from "assets/images/analytics/unlockIcon.svg";

import ViewsImage from "assets/images/analytics/views.svg";
import FavoritesImage from "assets/images/analytics/favorites.svg";
import ClonesImage from "assets/images/analytics/clones.svg";
import UnlocksImage from "assets/images/analytics/unlocks.svg";
import { image } from "d3";

export const filterOptions = [
    {
      label: "All Time",
      value: "all",
    },
    {
      label: "By Year",
      value: "year",
    },
    {
      label: "By Month",
      value: "month",
    },
    {
      label: "By Date Range",
      value: "date",
    },
];

export const boards = [
    {
        id: "most_viewed",
        key: "num_views",
        title: "Views",
        icon: ViewsIcon,
        image: ViewsImage,
        background: "#DDE5FF"
    },
    {
        id: "most_favorited",
        key: "num_favorites",
        title: "Favorites",
        icon: FavoritesIcon,
        image: FavoritesImage,
        background: "#FEECF4"
    },
    {
        id: "most_cloned",
        key: "num_clones",
        title: "Clones",
        icon: ClonesIcon,
        image: ClonesImage,
        background: "#EBFAFA"
    },
    {
        id: "most_unlocked",
        key: "num_unlocks",
        title: "Unlocks",
        icon: UnlocksIcon,
        image: UnlocksImage,
        background: "#FCEFD8"
    }
]